import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class MFMandateUploadUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.uploadMandateImg(req);
    }
}
export default MFMandateUploadUseCase;
